import React from "react";

const NotFound: React.FC = () => <>
    404
    </>

export default NotFound